import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import { Title, MainIcon, IconWrapper } from '../../../SharedStyles'

const ValuePropositionSmall = ({
  asset,
  title,
  link = false,
  alt,
  description,
  onMouseEnterHandler,
  onMouseLeaveHandler,
  click = () => {}
}) =>
  <ValueProposition
    href={ link }
    alt={ alt }
    onMouseEnter={ () => onMouseEnterHandler(alt) }
    onMouseLeave={ onMouseLeaveHandler }
    onClick={ click }>
    <IconWrapper>
      <MainIcon asset={ asset } />
    </IconWrapper>
    <CustomTitle>{ title }</CustomTitle>
    <Description>{ description }</Description>
  </ValueProposition>

ValuePropositionSmall.propTypes = {
  alt: PropTypes.string,
  asset: PropTypes.string,
  click: PropTypes.func,
  description: PropTypes.string,
  link: PropTypes.string,
  onMouseEnterHandler: PropTypes.func,
  onMouseLeaveHandler: PropTypes.func,
  title: PropTypes.string
}

export default ValuePropositionSmall

const ValueProposition = styled.a`
  padding: 20px 10px;
  width: 48%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: ${Theme.colors.white};
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  ${Media.desktop`
    &:hover {
      background: ${Theme.colors.red};
    }

    &:hover div {
      color: ${Theme.colors.white};
    }
  `}

  @media (max-width: 450px) {
    padding: 8px;
  }
`

const CustomTitle = styled(Title)`
  margin-top: 5px;
  ${Mixin.font.GothamBold(15)};

  @media (max-width: 500px) {
    ${Mixin.font.GothamBold(16)};
    margin-top: 10px;
  }

  @media (max-width: 400px) {
    ${Mixin.font.GothamBold(11)};
  }
`

const Description = styled.div`
  color: ${Theme.colors.medium_grey};
  ${Mixin.font.GothamMedium(13, 500)};
  margin-top: 10px;

  @media (max-width: 450px) {
    ${Mixin.font.GothamMedium(12, 500)};
  }
`
